import { render, staticRenderFns } from "./GlassBreakagePersonalPropertiesNonIncludedQuestion.vue?vue&type=template&id=ff2b84b0"
import script from "./GlassBreakagePersonalPropertiesNonIncludedQuestion.vue?vue&type=script&lang=ts"
export * from "./GlassBreakagePersonalPropertiesNonIncludedQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports